import React from 'react';

export function WrapIcon(icon: React.FC<React.SVGProps<SVGSVGElement>>) {
    return () =>
        React.createElement(icon, {
            className: 'text-[#D0D5DD]',
        });
}
